// extracted by mini-css-extract-plugin
module.exports = {"section":"Step3_section__3WPEa","image":"Step3_image__1DVi0","desc":"Step3_desc__HsaCq"};